import http from './http';
import {PROJECT_BASE} from './paths';
import {withPerm} from './perm';

// /v1.0/project/{pjtId}/member

export const listProjectMembers = withPerm(async (pjtId) => {
  const res = await http.get(`${PROJECT_BASE}/${pjtId}/member`);
  return res.data;
}, 'GET', `${PROJECT_BASE}/{pjtId}/member`);

export const addProjectMember = withPerm(async (pjtId, payload) => {
  const res = await http.post(`${PROJECT_BASE}/${pjtId}/member`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return res.data;
}, 'POST', `${PROJECT_BASE}/{pjtId}/member`);

export const removeProjectMember = withPerm(async (pjtId, pjtMbrId) => {
  const res = await http.delete(`${PROJECT_BASE}/${pjtId}/member/${pjtMbrId}`);
  return res.data;
}, 'DELETE', `${PROJECT_BASE}/{pjtId}/member/{pjtMbrId}`);

